export var SIMPLE_COURSE_CARD_TRANSLATION_KEY = 'simple-course-card';